import useScale from '@lib/hooks/useScale';
import type { ReactNode, CSSProperties } from 'react';

interface PresentationViewProps {
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
  targetId: string;
  linkTemp: { layoutMode: 'rectangle' | 'square' };
  isOnboarding?: boolean;
}

const PresentationView: React.FC<PresentationViewProps> = ({
  children,
  className,
  style,
  targetId,
  linkTemp,
  isOnboarding = false
}) => {
  const { scale, width, height } = useScale({
    targetId,
    layoutMode: linkTemp?.layoutMode,
    isOnboarding
  });

  return (
    <div
      className={className}
      style={{
        position: 'absolute',
        overflow: 'hidden',
        transformOrigin: 'left top',
        transform: `scale(${scale}) translate(-50%, -50%)`,
        width: `${width}px`,
        height: `${height}px`,
        left: '50%',
        top: '50%',
        background: 'white',

      }}>
      <div
        className="flex w-full h-full"
        style={{ ...style }}
      >
        {children}
      </div>
    </div>
  );
};

export default PresentationView;
